// ABOUTME: Trend adjustment slider component for controlling forecast trend weight.
// ABOUTME: Includes slider, reset button, and chart expand toggle.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Slider, Typography, IconButton, Tooltip } from '@mui/material';
import { RestartAlt as RestartAltIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';

function TrendSlider({
  trendWeight,
  onTrendWeightChange,
  onResetTrendWeight,
  trendWeightLoading,
  savedTrendWeight,
  chartExpanded,
  onChartExpandedChange,
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Trend Adjustment Slider */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          bgcolor: '#f3f4f6',
          borderRadius: '9999px',
          pl: 2,
          pr: 1,
          py: 0.5,
        }}
      >
        <Typography variant="caption" sx={{ color: '#6b7280', whiteSpace: 'nowrap' }}>
          {t('dashboard.forecast.trendDowOnly')}
        </Typography>
        <Slider
          value={trendWeight}
          onChange={(e, value) => onTrendWeightChange(value)}
          min={0}
          max={1}
          step={0.1}
          valueLabelDisplay="auto"
          valueLabelFormat={(v) => `${(v * 100).toFixed(0)}%`}
          disabled={trendWeightLoading}
          sx={{ width: 100, mx: 1 }}
        />
        <Typography variant="caption" sx={{ color: '#6b7280', whiteSpace: 'nowrap' }}>
          {t('dashboard.forecast.trendFullAdjust')}
        </Typography>
        <Tooltip title={t('common.resetToDefault')}>
          <IconButton
            size="small"
            onClick={onResetTrendWeight}
            disabled={trendWeightLoading || (savedTrendWeight === 1.0 && trendWeight === 1.0)}
            sx={{ color: '#6b7280', p: 0.5 }}
          >
            <RestartAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Chart expand/collapse toggle */}
      <Tooltip title={chartExpanded ? t('common.collapse') : t('common.expand')}>
        <IconButton
          onClick={() => onChartExpandedChange(!chartExpanded)}
          sx={{
            bgcolor: chartExpanded ? '#dbeafe' : '#f3f4f6',
            borderRadius: '8px',
            width: 40,
            height: 40,
            '&:hover': { bgcolor: chartExpanded ? '#bfdbfe' : '#e5e7eb' },
          }}
        >
          {chartExpanded ? (
            <ExpandLessIcon sx={{ color: '#1d4ed8' }} />
          ) : (
            <ExpandMoreIcon sx={{ color: '#374151' }} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default TrendSlider;
